import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Header from './components/elem/Header'

import UserContextProvider from './components/wrappers/UserContext'
import APIRequestContextProvider from './components/wrappers/APIRequestContext'

import urls from './utils/constants/urls'

import GlobalStyle from './theme/GlobalStyle'
import FormStateContextProvider, { FormStateContext } from './components/wrappers/FormStateContext'
import AsyncPage from './components/wrappers/AsyncPage'
import routePaths from './utils/constants/routePaths'
import EditorAccess from './components/features/user/EditorAccess'
import ViewerAccess from './components/features/user/ViewerAccess'

function App() {
    return (
        <React.Fragment>
            <GlobalStyle />
            <Header />
            <div className="contentWrapper">
                <Router>
                    <UserContextProvider>
                        <APIRequestContextProvider>
                            <FormStateContextProvider>
                                <Routes>
                                    <Route
                                        exact
                                        path={urls.userCallback}
                                        element={<AsyncPage page={routePaths.callback} />}
                                    />
                                    <Route
                                        exact
                                        path="/"
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage page={routePaths.landing} />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/facilities"
                                        element={<AsyncPage page={routePaths.facilities} />}
                                    />
                                    <Route
                                        exact
                                        path="/bidPackages"
                                        element={
                                            <AsyncPage page={routePaths.bidPackages} />
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/bidResponse/new'}
                                        element={
                                            <EditorAccess>
                                                <AsyncPage page={routePaths.bidResponse} />
                                            </EditorAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/bidResponses"
                                        element={
                                            <AsyncPage page={routePaths.bidResponses} />
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/bidPackage/new'}
                                        element={
                                            <EditorAccess>
                                                <AsyncPage page={routePaths.bidPackage} />
                                            </EditorAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path="/invoices"
                                        element={
                                            <AsyncPage page={routePaths.invoices} />
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/invoice/new'}
                                        element={
                                           <EditorAccess>
                                                <AsyncPage page={routePaths.invoice} />
                                            </EditorAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/facility/new'}
                                        element={
                                            <EditorAccess>
                                                <AsyncPage page={routePaths.facility} />
                                            </EditorAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/facility/:facilityId'}
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage page={routePaths.facility} />
                                            </ViewerAccess>
                                        }
                                    />
                                    
                                    <Route
                                        exact
                                        path={'/bidPackage/:bidPackageId'}
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage page={routePaths.bidPackage} />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/bidResponse/:bidResponseId'}
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage page={routePaths.bidResponse} />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route
                                        exact
                                        path={'/invoice/:invoiceId'}
                                        element={
                                            <ViewerAccess>
                                                <AsyncPage page={routePaths.invoice} />
                                            </ViewerAccess>
                                        }
                                    />
                                    <Route path="/login" element={<AsyncPage page={routePaths.login} />} />
                                </Routes>
                            </FormStateContextProvider>
                        </APIRequestContextProvider>
                    </UserContextProvider>
                </Router>
            </div>
            <ToastContainer />
        </React.Fragment>
    )
}

export default App
